import type { SocialShareLink } from "../get-data/transform/share-links";

const UPDATE_SHARE_LINKS = 'UPDATE_SHARE_LINKS';

export type State = SocialShareLink[];

export const updateShareLinks = (payload) => ({
    type: UPDATE_SHARE_LINKS,
    payload,
});

export default (state: State = [], action): State =>
    action.type === UPDATE_SHARE_LINKS ? action.payload : state;
